import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CreateWorkbookReminderPayload, GetWorkbookReminderPayload, UpdateWorkbookReminderPayload } from '../models/workbook-reminder.models';

@Injectable({
  providedIn: 'root'
})
export class WorkbookReminderService {
  dynamicTableAPI: string;
  constructor(private readonly http: HttpClient) {
    this.dynamicTableAPI = environment.dynamicTableAPI; 
   }
   
  // Get Workbook Reminder 
  getWorkbookReminder(reminder: GetWorkbookReminderPayload): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Reminder/bulk`, reminder);
  }

  // Add new Reminder
  addNewWorkbookReminder(newReminder: CreateWorkbookReminderPayload): Observable<any> {
    return this.http.post<any>(`${this.dynamicTableAPI}Reminder`, newReminder);
  }
  
  // Update Existing Reminder
  updateWorkbookReminder(updatedReminder: UpdateWorkbookReminderPayload): Observable<any> {
    return this.http.put<any>(`${this.dynamicTableAPI}Reminder`, updatedReminder);
  }

  //deleteWorkbookReminder 
  deleteWorkbookReminder(reminderId: string) {
    return this.http.delete<any>(`${this.dynamicTableAPI}Reminder/${reminderId}`);
  }

}
